// extracted by mini-css-extract-plugin
export var card = "_lp-5";
export var cardSelected = "_lp-4";
export var image = "_lp-3";
export var modal = "_lp-0";
export var modalContent = "_lp-1";
export var table = "_lp-2";